// extracted by mini-css-extract-plugin
export default {"button":"Button_button__DQwpv","text":"Button_text__kTKwT","leftIcon":"Button_leftIcon__AFpJg","rightIcon":"Button_rightIcon__tKC0I"};